var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136 231.996H482.701L306.734 78.025C303.406 75.119 303.062 70.056 305.984 66.712C308.906 63.4 313.953 63.087 317.266 65.962L509.266 233.965C511 235.496 512 237.684 512 239.997C512 242.309 511 244.497 509.266 246.028L317.266 414.031C315.75 415.343 313.875 415.999 312 415.999C309.781 415.999 307.562 415.062 305.984 413.281C303.062 409.937 303.406 404.874 306.734 401.968L482.701 247.997H136C69.828 247.997 16 301.841 16 367.999V440C16 444.406 12.422 448 8 448S0 444.406 0 440V367.999C0 292.997 61.016 231.996 136 231.996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e0cfa45ebee5d19c8fe8529357ffb1c1.svg";
export { ForwardRef as ReactComponent };